module.exports = __webpack_public_path__ + "img/render.70e6e148.png";